import(/* webpackMode: "eager" */ "/vercel/path0/web/web/node_modules/@mui/material/Box/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/web/web/src/components/AuthenticatedShell.tsx");
